import React from 'react';
import {IconButton, IconButtonProps} from '@common/components/Button';
import {ReactComponent as EditIcon} from '@gakki/assets/edit.svg';
import {ReactComponent as TrashIcon} from '@gakki/assets/trash.svg';
import './style.css';

const svgs = {
  'edit': <EditIcon className={'text-xl'} />,
  'trash': <TrashIcon className={'text-xl'} />
}
type CustomIconButtonProps = IconButtonProps & { text?: string, icon: keyof typeof svgs };
export const CustomIconButton = React.forwardRef<HTMLButtonElement, CustomIconButtonProps>(({text,icon,className = '', ...props}, ref) => {
  return (
    <IconButton
      {...props}
      className={`custom-icon-button !px-0 ${className}`}
      ref={ref}
    >
      {svgs[icon]}
      {text}
    </IconButton>
  );
})